<template>
  <div class="sidebar-menu">
    <div class="sidebar-menu-container">
      <div class="sidebar-icons">
        <ul class="navbar-nav navbar-stacked">
          <li class="nav-item top-icon-links">
            <a class="nav-link categories" href="javascript:void(0)">
              <img :src="asset('/home-layout/files/categories.png')" alt="Categories Icon" />
              <br />Categories
            </a>
          </li>
          <li class="nav-item top-icon-links">
            <a class="nav-link genres" href="javascript:void(0)">
              <img :src="asset('/home-layout/files/genres.png')" alt="Genres Icon" />
              <br />Genres
            </a>
          </li>
          <li class="nav-item top-icon-links d-cs-none">
            <router-link active-class="active" class="nav-link" to="/movies">
              <img :src="asset('/home-layout/files/video-player.png')" alt="Movie Icon" />
              <br />Movies
            </router-link>
          </li>
          <li class="nav-item top-icon-links d-cs-none">
            <router-link active-class="active" class="nav-link" to="/tv-shows">
              <img :src="asset('/home-layout/files/smart-tv.png')" alt="TV Icon" />
              <br />TV Shows
            </router-link>
          </li>
          <li class="nav-item top-icon-links d-cs-none">
            <a class="nav-link live-active"  :href="httpUrl + '#/live/home?__k=' + token">
              <img :src="asset('/home-layout/files/television.png')" alt="Live TV Icon" />
              <br />Live TV
            </a>
          </li>
          <li class="nav-item top-icon-links d-cs-none">
            <router-link active-class="active" class="nav-link" to="/discover">
              <img :src="asset('/home-layout/files/binoculars.png')" alt="Discovery Icon" />
              <br />Discover
            </router-link>
          </li>
        </ul>
      </div>
      <div class="sidebar-menu-body">
        <div class="header-search">
          <SearchForm />
        </div>

        <ul class="navbar-nav navbar-stacked categories-ul">
          <h4 class="my-2">CATEGORIES</h4>
          <li class="nav-item py-2">
            -
            <a href="#" @click="switchCategory($event, 'all')">All</a>
          </li>
          <li class="nav-item py-2">
            -
            <a href="#" @click="switchCategory($event, 'premier')">Premier</a>
          </li>
          <li class="nav-item py-2">
            -
            <a href="#" @click="switchCategory($event, 'recently-added')">Recently Added</a>
          </li>
          <li class="nav-item py-2">
            -
            <a href="#" @click="switchCategory($event, 'recently-watched')">Recently Watched</a>
          </li>
          <li class="nav-item py-2">
            -
            <a href="#" @click="switchCategory($event, 'favorite')">Favourite</a>
          </li>
          <li class="nav-item py-2">
            -
            <a href="#" @click="switchCategory($event, 'watch-later')">Watch Later</a>
          </li>
        </ul>
        <ul class="navbar-nav navbar-stacked genres-ul" style="display: none;">
          <h4 class="my-2">Genres</h4>
          <perfect-scrollbar id='scrollbar'>
            <li class="nav-item py-2" v-for="(genre, key) in genres" :key="key">
              -
              <a class="genre-btn" href="#" @click="switchGenre($event, genre)">
                {{ genre }}
              </a>
            </li>
          </perfect-scrollbar>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import { getAppResource, getAuthKey } from '../app/helpers';
import SearchForm from './SearchForm'
import { httpUrl } from '../app/config';


export default {
  data() {
    return {
      genres: null,
      year: '',
      title: '',
      httpUrl,
      token: null,
    }
  },
  components: {
        PerfectScrollbar,
        SearchForm
    },
  async mounted() {
    const genres = await getAppResource('genres')

    this.genres = genres;
    this.token = getAuthKey();

    $(".categories").click(function() {
      $(".sortby,.genres").css("color", "#fff");
      $(this).css("color", "#c70c13");
      $(".sortby-ul,.genres-ul").hide();
      $(".categories-ul").show();
    });
    $(".genres").click(function() {
      $(".sortby,.categories").css("color", "#fff");
      $(this).css("color", "#c70c13");
      $(".categories-ul,.sortby-ul").hide();
      $(".genres-ul").show();

      const windowHeight = window.innerHeight;
      const psTop = $('#scrollbar').offset().top || 200;
      $("#scrollbar").css('height', windowHeight - psTop - 40);
    });
  },
  methods: {
    switchCategory(e, category) {
      e.preventDefault();
      
      this.$router.push({
        name: 'category',
        params: { category }
      })
    },

    switchGenre(e, genre) {
      e.preventDefault();

      this.$router.push({
        name: 'genre',
        params: { genre }
      })

    },
  },

  watch : {
    $route () {
      $(".sidebar-menu").removeClass("sidebar-opened");
      $(".toggle-sidebar").removeClass("opened");
      $("body").removeClass("has-sidebar");
    }
  }
};
</script>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>